// BE-returned document URLs are untrusted. Allow same-origin relative paths
// or explicit https URLs; reject everything else (javascript:, data:, http:,
// etc.). Cross-origin https is intentionally permitted for S3 / CloudFront
// signed-document URLs.
export function getSafeESignDocumentUrl(rawUrl?: string | null) {
  if (!rawUrl?.trim()) {
    return null;
  }

  try {
    const normalizedUrl = rawUrl.trim();
    const url = new URL(normalizedUrl, window.location.origin);
    const hasExplicitScheme = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(normalizedUrl);

    if (hasExplicitScheme && url.protocol !== 'https:') {
      return null;
    }

    if (!hasExplicitScheme && url.origin !== window.location.origin) {
      return null;
    }

    return url.toString();
  } catch {
    return null;
  }
}
